export default "__VITE_ASSET__Ci2Y1vAB__"